import React from 'react';
import { SvgIcon } from 'components/SvgIcon';
import { IThankYou } from 'services/ThankYouService';
import { enNormalizedPaymentType } from 'enums/enPaymentMethod';

interface IProps {
  model: IThankYou;
}

export const Ticket = (props: IProps) => (
  <React.Fragment>
    <div className={'message'}>
      {props.model.paymentResult.paymentMethod === enNormalizedPaymentType.BANKSLIP ?
        <p>Você receberá seu ticket no seu <b>e-mail</b> assim que
         o pagamento do boleto for confirmado. Enquanto isso, confirme os seus dados de compra. </p> :
        <p>Estamos preparando com carinho a entrega do seu ticket. Você receberá no seu <b>e-mail</b> o ticket
        do evento. Enquanto isso, confirme os seus dados de compra. </p>
      }    </div>
    <div className={'data'}>
      <div className={'user'}>
        <p><SvgIcon name='user' /><span>{props.model.studdent ? props.model.studdent.name : props.model.user.name}</span></p>
        <p><SvgIcon name='email' /><span>{props.model.studdent ? props.model.studdent.email : props.model.user.email}</span></p>
      </div>
    </div>
    <div className={'alert'}>
      Em caso de dúvidas, ou se você precisar de suporte, entre em contato com o vendedor pelo e-mail <b>{props.model.content.producerEmail}</b>.
    </div>
  </React.Fragment>
);